import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface InitialState {
  titles: {
    [key: string]: string
  }
}

const initialState: InitialState = { titles: {} }

export const conversationSlice = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    setConversationTitle: (
      state: InitialState,
      action: PayloadAction<{ uuid: string; title: string }>
    ) => {
      const { uuid, title } = action.payload
      state.titles[uuid] = title
    },
    clearConversationTitles(state: InitialState) {
      state.titles = {}
    }
  }
})

export const { setConversationTitle, clearConversationTitles } = conversationSlice.actions
export default conversationSlice.reducer
